<template lang="pug">
BriqDurationInput(
  :value="value"
  @input="e => $emit('input', e)"
  :label="customField.FieldName" 
  placeholder="HH:mm:ss" 
  :required="!customField.Optional"
  :name="customField.FieldCode" 
  :error="error"
  data-test-id="custom-field-duration"
  )
</template>

<script>
import { validateProps } from '@v/util/propValidators.js'
import BriqDurationInput from '@v/components/BriqDurationInput.vue'

export default {
  name: 'CustomFieldDuration',
  components: { BriqDurationInput },
  props: {
    customField: {
      type: Object,
      validator: validateProps(['FieldCode', 'FieldName', 'Optional', 'Description']),
    },
    value: String,
    error: String,
  },
}
</script>
